import { useInvestorTransferReviewNAVTableDataRetrieveSuspense } from "gen/endpoints/investor-transfer/investor-transfer";
import { useTranslation } from "react-i18next";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";

export interface InvestorTransferNavSummaryTableProps {
  fundFamilyId: string;
  investorTransferId: string;
}

export const InvestorTransferNavSummaryTable: React.FC<
  InvestorTransferNavSummaryTableProps
> = ({ investorTransferId, fundFamilyId }) => {
  const { t } = useTranslation(["investorTransfer"]);

  const { data: navSummaryData } =
    useInvestorTransferReviewNAVTableDataRetrieveSuspense(
      fundFamilyId,
      investorTransferId,
    );

  return (
    <TableBox>
      <TableBoxHeader>
        <TableBoxTitle>
          {t("investorTransfer:setup.review.navSummaryTable.title")}
        </TableBoxTitle>
        <DataTableBoxActions />
      </TableBoxHeader>
      <TableBoxBody>
        <DataTable data={navSummaryData} />
      </TableBoxBody>
    </TableBox>
  );
};
